import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import useResponsive from '@/hooks/useResponsive';

interface LabelsProps {
  item: Array<{
    name: string;
    value: number | string;
    realQuantity: number | string;
    color: string;
  }>;
}

const titles = ['En curso', 'Completados', 'En revisión'];

const Labels = ({ item }: LabelsProps) => {
  const isMobile = useResponsive('down', 'sm');
  const items: Array<{
    name: string;
    value: number | string;
    realQuantity: number | string;
    color: string;
  }> = [];
  let title: {
    name: string;
    value: number | string;
    realQuantity: number | string;
    color: string;
  } = {
    name: '',
    value: 0,
    realQuantity: 0,
    color: '#12344A',
  };

  item.forEach((item) => {
    if (titles.includes(item.name)) {
      title = item;
    } else {
      items.push(item);
    }
  });

  return (
    <Box ml="1rem" sx={{ display: isMobile ? 'flex' : 'block', flexDirection: 'column' }}>
      <Title color={title.color} isMobile>
        {title.value}% {title.name}
      </Title>
      {items
        .slice()
        .sort((a, b) => Number(b.value) - Number(a.value))
        .map((item) => (
          <Box display="flex" alignItems="center" ml="1rem" key={item.name}>
            <div
              style={{
                backgroundColor: item.color,
                width: '1rem',
                height: '1rem',
                marginRight: '0.4rem',
              }}
            />
            <Item key={item.name} color={item.color}>
              {item.value}% {item.name} ({item.realQuantity})
            </Item>
          </Box>
        ))}
    </Box>
  );
};

export default Labels;

const Item = styled(Typography)(() => ({
  margin: '0.3rem 0',
  color: '#9697AF',
}));

const Title = styled(Typography)(({ color, isMobile }: { color: string; isMobile: boolean }) => ({
  color,
  alignSelf: isMobile ? 'center' : 'flex-start',
  fontWeight: 'bold',
  margin: '0.5rem 0',
}));
